module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/howto-step3-b11c9c68b97ee5529546430f280e675f.svg";